<template>
  <a :class="['btn', `btn--${customClass}`]" :href="href" target="_blank">
    <!-- <img :src="`${RESOURCES_URL}${imgUrl}`" alt=""> -->
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BaseBtn',
  props: {
    href: {
      type: String
    },
    customClass: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('data', ['RESOURCES_URL'])
  }
}
</script>

<style lang="scss">
.btn {
  &--facebook,
  &--linked-in,
  &--instagram,
  &--youtube {
    @include button-reset;

    position: relative;
    display: block;

    &::before {
      @include absolute-center;

      content: '';
    }
  }

  &--facebook {
    width: 35px;
    height: 36.8px;
    background: url('~/static/img/facebook-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 6px;
      height: 13px;
      background: url('~/static/img/icon-facebook.svg') no-repeat center;
      background-size: cover;
    }
  }

  &--linked-in {
    width: 35px;
    height: 32px;
    background: url('~/static/img/linkedin-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 15px;
      height: 14px;
      background: url('~/static/img/icon-linkedin.svg') no-repeat center;
      background-size: cover;
    }
  }

  &--instagram {
    width: 36px;
    height: 35px;
    background: url('~/static/img/instagram-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 15px;
      height: 15px;
      background: url('~/static/img/icon-instagram.svg') no-repeat center;
      background-size: cover;
    }
  }

  &--youtube {
    width: 35px;
    height: 28px;
    background: url('~/static/img/youtube-shape@mb.svg') no-repeat center;
    background-size: cover;

    &::before {
      width: 16.8px;
      height: 12px;
      background: url('~/static/img/icon-youtube.svg') no-repeat center;
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseSocialLink.vue